import { GAMES_PER_SLIDE_MIN } from './constants';

// Possibly, there's better way
export const getRightMargin = (gameRef) => {
    let marginRight = parseFloat(getComputedStyle(gameRef).marginRight);

    if (marginRight !== 0) {
        return marginRight;
    }

    // for single element in slide possible margin won't be drawn hence we couldn't be able to calculate it
    const el = document.createElement('span');

    gameRef.parentElement.appendChild(el);
    marginRight = parseFloat(getComputedStyle(gameRef).marginRight);
    gameRef.parentElement.removeChild(el);

    return marginRight;
};

export const getTotalGamesCount = (containerEl, gameEl) => {
    const { floor, max } = Math;
    const { offsetWidth } = containerEl;
    const { paddingLeft, paddingRight } = getComputedStyle(containerEl);
    const { width: gameWidth } = getComputedStyle(gameEl);
    const gameMarginRight = getRightMargin(gameEl);
    const containerWidth = offsetWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
    const minTotalGameWidth = parseFloat(gameWidth) + gameMarginRight;
    const gamesCount = floor(containerWidth / minTotalGameWidth);

    return max(gamesCount, GAMES_PER_SLIDE_MIN);
};
